var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{staticClass:"\n      font-AvenirBlackFont\n      mt-auto\n      ml-auto\n      hover:underline\n      cursor-pointer\n      text-gray-600 text-sm\n    ",on:{"click":_vm.downloadAll}},[_vm._v("Download all ")])])}
var staticRenderFns = []

export { render, staticRenderFns }